import React from 'react'

import { cn, getHighlightedLinesRange, normaliseCodeLanguage } from '../../lib/helpers'
import CopyButton from '../copyButton'
import { small } from './../typography.module.css'
import styles from './codeBlock.module.css'

const CodeBlock = ({ code, language, highlightedLines, filename }) => {
  return (
    <div className={cn(styles.container, !filename ? styles.noTopMargin : '')}>
      {filename && <code className={cn(styles.filename, small)}>{filename}</code>}
      <pre
        data-line={getHighlightedLinesRange(highlightedLines)}
        className={cn(styles.container, `language-${normaliseCodeLanguage(language)}`)}
      ><code>{code}</code>
      </pre>
      <CopyButton text={code} />
    </div>
  )
}

export default CodeBlock
